module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1